





































import { Vue, Component } from 'vue-property-decorator'
import Conversations from './Conversations.vue'
import NewConversationDialog from '@/views/messages/NewConversationDialog.vue'

@Component({
  metaInfo: {
    title: 'Messages',
  },
  components: { Conversations, NewConversationDialog }
})
export default class Messages extends Vue {
  newConversationDialog = false
  transitionFinished = false

  mounted() {
    setTimeout(() => {
      this.transitionFinished = true
    }, 50)
  }
}
